import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { FormattedHTMLMessage } from 'react-intl';

class InlineHeader extends React.Component {
  onMessageBarDismissed = () => {
    this.title.focus();
  }

  setTitle = (h1) => {
    this.title = h1;
  };

  renderTitleDescription() {
    if (this.props.titleDescription) {
      return (
      <div>
        <FormattedHTMLMessage
          {...this.props.titleDescription}
        />
      </div>);
    }

    return null;
  }

  render() {
    return (
      <Grid>
        <Row className="kiosk-header-row">
          <Col xs={12} sm={12} md={6}>
            {
              this.props.headerTitle ?
                <h1 className="header" id="content" data-qa-item="pageHeader"
                  aria-describedby={this.props.ariaDescribedby} tabIndex="0"
                  ref={this.setTitle}
                >
                  <span className="title" >
                    {this.props.headerTitle }
                  </span>
                </h1> :
                <span id="content"></span>
            }
          </Col>
          <Col xs={12} sm={12} md={6}>
            {this.props.children}
          </Col>
        </Row>
        <Row className="kiosk-header-row">
          <Col xs={12}>
            {this.renderTitleDescription()}
          </Col>
        </Row>
      </Grid>
    );
  }
}

InlineHeader.propTypes = {
  headerTitle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  titleDescription: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  ariaDescribedby: PropTypes.string,
  children: PropTypes.object,
};

export default InlineHeader;
